// extracted by mini-css-extract-plugin
export default {"footer":"LandingFooter_footer__J2NrT","footerText":"LandingFooter_footerText__MAEis"};